export default __webpack_public_path__ + "static/media/Picture2.264df718.jpg";